<script lang="ts">
    import { defineComponent } from 'vue';

    export default defineComponent({

    });
</script>

<template>
    <div class="card is-flex">
        <div class="card-image is-clipped">
            <picture class="image is-4by3 is-skeleton">
                <img width="400" 
                     height="300" 
                     alt="Placeholder image">
            </picture>
        </div>
        <div class="card-content is-flex-grow-1 is-flex is-flex-direction-column">
            <h3 class="title is-4 has-skeleton">
                Title
            </h3>
            <div class="tags">
                <div v-for="index in 3" 
                     :key="index" 
                     class="tag is-skeleton">
                    Tag
                </div>
            </div>
            <div class="skeleton-lines">
                <div />
                <div />
                <div />
            </div>
        </div>
    </div>
</template>
